module.exports = __webpack_public_path__ + "static/media/transporte.2e117bdc.svg";